module.exports = __webpack_public_path__ + "media/images/teams/LAZIO-5ebe8181ffd483214ca8844c3445fd12.png";